
import '../components/css components/About.css';
import ImageSlider from "./ImageSlider";
import mega from "../images/home.jpg";
import mega2 from "../images/mega_workshop.jpg";
import mega3 from "../images/mega_workshop2.jpg";
import e5 from "../images/megcast5.jpg";
import megaverse from "../images/megaverse.jpg";
import fight from "../images/fight.jpg";
import make from "../images/make.jpg"
import { Container } from 'react-bootstrap';
import "animate.css/animate.min.css";
import ylf from "../images/ylf.jpg"
import workshop from "../images/workshop.jpg";

function About(){
    const images = [
        mega,
        mega2,
        mega3
    ];
    return(
        <div className='about' id='#about'>
                <h2 className='title'>about us</h2>
                <div className='contain'>
                <ImageSlider images={images} />
                {/* <div className='slider'>
                    </div> */}
                    <p> 
                            Mega is a volunteering Team interested in computer science & Information Technology field, founded in 2018 at Faculty of Computer and Information science.
                            Mega Team aims to help all enthusiasts In Tech and Career development fields by Providing Them with best Facilities, Tools and mentors.
                            <h3>Our Goal :</h3>
                            The team aspires to form a growing community that includes all those wishing to learn the fields of computer science and technology, and this community becomes an integrated environment that qualifies them for the labor market by qualifying them scientifically and technically in addition to personal skills and Expand our activity all over Egypt.
                    </p>
                </div>
                <h2 className='title-achieve'>Achievments :</h2>
                <div className='achieve'>
                    <div className='card achieve-card'>
                        <img src={e5} alt='episode'/>
                        <h2>Megcast</h2>
                        <p>An educational podcast designed specifically for students looking to boost their productivity and stand out from the crowd. it offers practical tips and insights on time management, study techniques, personal development, and career planning. Whether you're in high school or college, "Megcast" provides the guidance and inspiration you need to excel academically and personally.Click <a href='https://www.youtube.com/watch?v=QTapC0nVUDY&list=PLTZ24f4xNtFQDVWLY9CXVwIShemeORzkm' target='_blank'>here</a> to listen.</p>
                    </div>
                    <div className='card achieve-card'>
                        <img src={megaverse} alt='megaverse event'/>
                        <h2>MegaVerse</h2>
                        <p>"Megaverse," an event dedicated to the exploration of the metaverse. This groundbreaking gathering brought together a remarkable assembly of over 10 distinguished speakers, each offering unique insights into the rapidly evolving realm of the metaverse."Megaverse" fostered engaging discussions and in-depth explorations of the metaverse's potential impact on our digital landscape. </p>
                    </div>
                    <div className='card achieve-card'>
                        <img src={workshop} alt='megaverse event'/>
                        <h2>Get Switched On</h2>
                        <p>"Get switched on" workshop was organized by us to assist students in getting started with the track, conducted in collaboration with <b>UCCD</b> and certified by them. This workshop aimed to provide students with the necessary knowledge and skills to begin their journey in the field. It covered various topics, including front-end,  back-end development, flutter development and Security.</p>
                    </div>
                    <div className='card achieve-card'>
                        <img src={fight} alt='Event'/>
                        <h2>Fight Fear</h2>
                        <p>"Fight Fear" event stands as a significant milestone in our journey of empowering students within the field of computer science. This event was a testament to our commitment to breaking down barriers and instilling confidence in aspiring technologists. With the aim of helping students overcome their fears and uncertainties, 'Fight Fear' provided a transformative experience. It encouraged individuals to take their first steps toward mastering the world of computer science. </p>
                    </div>
                    <div className='card achieve-card ylf'>
                        <img src={ylf} alt='episode'/>
                        <h2>YLF Finalists</h2>
                        <p>YLF Leaders League is a prestigious national competition encompassing a wide range of student activities. We are proud to have reached the finals in the Leaders League 3 competition, specifically in the field of Technology and Innovation. Our achievement stands out among 500 student initiatives, showcasing our innovative concept. This recognition underscores our commitment to making a meaningful impact on society through technology and innovation.</p>
                    </div>
                </div>
        </div>
    );
}

export default About;